var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5604_9456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "url(#paint0_radial_5604_9456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5586 15.4473C16.582 11.5176 23.1133 11.5176 27.1367 15.4473L27.6211 15.9238C27.8242 16.1191 27.8242 16.4395 27.6211 16.6348L25.9648 18.252C25.8633 18.3535 25.6992 18.3535 25.5977 18.252L24.9336 17.6035C22.1211 14.8613 17.5742 14.8613 14.7617 17.6035L14.0508 18.2988C13.9492 18.4004 13.7852 18.4004 13.6836 18.2988L12.0273 16.6816C11.8242 16.4863 11.8242 16.166 12.0273 15.9707L12.5586 15.4473ZM30.5664 18.791L32.043 20.2285C32.2461 20.4238 32.2461 20.7441 32.043 20.9395L25.3945 27.4316C25.1914 27.627 24.8633 27.627 24.668 27.4316L19.9492 22.8223C19.9023 22.7754 19.8164 22.7754 19.7695 22.8223L15.0508 27.4316C14.8477 27.627 14.5195 27.627 14.3242 27.4316L7.65234 20.9395C7.44922 20.7441 7.44922 20.4238 7.65234 20.2285L9.12891 18.791C9.33203 18.5957 9.66016 18.5957 9.85547 18.791L14.5742 23.4004C14.6211 23.4473 14.707 23.4473 14.7539 23.4004L19.4727 18.791C19.6758 18.5957 20.0039 18.5957 20.1992 18.791L24.918 23.4004C24.9648 23.4473 25.0508 23.4473 25.0977 23.4004L29.8164 18.791C30.0352 18.5957 30.3633 18.5957 30.5664 18.791Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5604_9456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.000123978 20.0006) scale(40)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5604_9456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.4989097a472247fd84241cc3626b21c5.svg";
export { ForwardRef as ReactComponent };